export default class TranslationProvider {

    static translations = {};
    static defaultTranslations = {};

    static get lang() {
        return document.documentElement.lang || "it";
    }

    static async init(json, jsonDefault = {}) {

        this.translations = json;
        this.defaultTranslations = jsonDefault;
        
    }

    static get(key, replacements = []) {

        // 1. Prova lingua corrente
        let value = this.getNestedValue(this.translations, key);

        // 2. Se non trovato, prova default
        if (value == null) { value = this.getNestedValue(this.defaultTranslations, key); }

        // 3. Se ancora null → errore
        if (value == null) { console.error("Chiave di traduzione mancante: '" + key + "'"); return key; }

        // 4. Sostituzione placeholder
        if (Array.isArray(replacements) && replacements.length > 0) {
            replacements.forEach((rep, idx) => {
                value = value.replace(new RegExp("\\{" + idx + "\\}", "g"), rep);
            });
        }

        return value;

    }

    static getNestedValue(obj, key) {

        const segments = key.split('.');
        let current = obj;

        for (const segment of segments) {
            if (typeof current !== 'object' || current === null || !(segment in current)) {
                return null;
            }
            current = current[segment];
        }

        return current;

    }

}